import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button, Grid, Link, Typography, units } from '@hbf/dsl';
import { LinkIcon } from 'ha/ui/Icons';
import { VpLargeComponentWithLinkData } from './types';

const useStyles = makeStyles()(theme => ({
  title: {
    marginBottom: units.rem(1),
    [theme.breakpoints.up('md')]: {
      marginBottom: units.rem(1.5),
    },
  },
  descriptionContainer: {
    [theme.breakpoints.down('md')]: {
      marginBottom: units.rem(1.5),
    },
  },
  container: {
    marginBottom: units.rem(2.5),
  },
  icon: {
    color: theme.palette.secondary.main,
    marginRight: units.rem(0.5),
    marginBottom: units.rem(0.5),
  },
  sideBarTitle: {
    marginBottom: units.rem(1),
  },
}));

export interface Props {
  valueProposition: VpLargeComponentWithLinkData;
}

export const VpLargeWithLinks: React.FC<Props> = ({ valueProposition }) => {
  const { classes } = useStyles();
  const hasLink = React.useMemo(
    () => !!valueProposition.sideBarLinksData.length,
    [valueProposition.sideBarLinksData.length],
  );

  return (
    <div>
      <Typography.H1 className={classes.title} component="h3">
        {valueProposition.title}
      </Typography.H1>
      <Grid
        container
        justifyContent="space-between"
        className={classes.container}
      >
        <Grid
          item
          xs={12}
          md={hasLink ? 6 : 12}
          className={classes.descriptionContainer}
        >
          <Typography.Paragraph>
            {valueProposition.description}
          </Typography.Paragraph>
        </Grid>
        {hasLink && (
          <Grid item xs={12} md={4}>
            <Typography.ParagraphTitle className={classes.sideBarTitle}>
              {valueProposition.sideBarTitle}
            </Typography.ParagraphTitle>
            {valueProposition.sideBarLinksData.map(link => (
              <Link to={link.url} key={link.title}>
                <Grid container wrap="nowrap">
                  <LinkIcon className={classes.icon} />
                  {link.title}
                </Grid>
              </Link>
            ))}
          </Grid>
        )}
      </Grid>
      {valueProposition.ctaUrl && (
        <Button
          href={valueProposition.ctaUrl}
          color="primary"
          variant="contained"
        >
          {valueProposition.ctaTitle}
        </Button>
      )}
    </div>
  );
};
